import { useState } from "react";
import userData from '../../Users.json';
import { Link, useNavigate } from "react-router-dom";
import './Settings.css';

function Settings() {
  const [searchInput, setSearchInput] = useState('');
  const [filterOption, setFilterOption] = useState('all');
  const navigate = useNavigate();



  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  }

  const handleFilterChange = (event) => {
    const selectedOption = event.target.value;
    setFilterOption(selectedOption);

    // Reset the search input when the filter option changes
    setSearchInput('');
  };


  // return badge class by permission status
  const getPermissionBadge = (permission) => {
    if (permission == 0) {
      return 'badge rounded-pill bg-info fs-12px badge-info-style';
    } else {
      return 'badge rounded-pill bg-secondary fs-12px'
    }
  };


  // Get block or not blocked text by user status
  const getStatusText = (status) => {
    if (status === 0) {
      return '사용';
    } else if (status === 1) {
      return '미사용';
    }
  };

  // Filter data based on the search input and filter option
  const filteredDataWithSearch = userData.filter((item) => {
    if (filterOption === '0') {
      return true; // No filter selected, show all data
    }

    if (filterOption === 'username') {
      return item.username
        .toLowerCase()
        .includes(searchInput.toLowerCase());
    } else if (filterOption === 'email') {
      return item.email.toLowerCase().includes(searchInput.toLowerCase());
    } else if (filterOption === 'company_number') {
      return item.company_number.toLowerCase().includes(searchInput.toLowerCase());
    } else if (filterOption === 'permission') {
      return item.permission.toLowerCase().includes(searchInput.toLowerCase());
    }

    return true;
  });

  // Move on setting clicked user
  function handleSettingUser(userId) {
    navigate(`/user_setting/${userId}`);
  }



  return (
    <>
      <div class="card mb-3">
        <div class="hljs-container border-0 rounded">
          <div className="container">

            <div className="row">
              <div class="card-body">
                <div class="row gy-2 gx-2 align-items-center">
                  <div class="col-12 col-md-3 col-xxl-2">
                    <div class="input-group flex-nowrap">
                      <span class="input-group-text" id="addon-wrapping"><i className='fas fa-search' /></span>
                      <label class="visually-hidden" for="selMaterialType">
                        검색 필터
                      </label>
                      <select
                        class="form-select"
                        id="selMaterialType"
                        onChange={handleFilterChange}
                        value={filterOption}
                      >
                        <option value="username">사용자명</option>
                        <option value="email">제목</option>
                        <option value="company_number">사번</option>
                        <option value="permission">권한</option>
                      </select>
                    </div>
                  </div>

                  <div id="divMaterialName" class="col-12 col-md-6 col-xxl-3">

                    <label class="visually-hidden" for="materialName">
                      검색
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="materialName"
                      placeholder="검색"
                      value={searchInput}
                      
                      onChange={handleSearchInputChange}
                    />
                  </div>

                  <div class="col-6 col-md-2 col-xxl-1"></div>
                </div>
              </div>
            </div>
            <div className="row">
              <div class="tab-content p-4">

              </div>
              {/* </div> */}

              <div class="table-responsive">
                <table class="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th class="border-top-0 pt-0 pb-2">사용자명</th>
                      <th class="border-top-0 pt-0 pb-2">이메일</th>
                      <th class="border-top-0 pt-0 pb-2">사번</th>
                      <th class="border-top-0 pt-0 pb-2">권한</th>
                      <th class="border-top-0 pt-0 pb-2">상태</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredDataWithSearch.map((item, index) => (
                      <tr key={item.company_number} onClick={() => handleSettingUser(index)}>
                        <td className="align-middle">{item.username}</td>
                        <td className="align-middle">{item.email}</td>
                        <td className="align-middle">{item.company_number}</td>
                        <td className="align-middle">{item.permission}</td>
                        <td className="py-1 align-middle">
                          <span className={getPermissionBadge(item.block)}>
                            {/* <i className="fa fa-circle fs-9px fa-fw me-5px"></i>{' '} */}
                            {getStatusText(item.block)}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div class="d-lg-flex align-items-center">
                <div class="me-lg-auto text-md-left text-center mt-2 mt-lg-0 mb-2 mb-lg-0">
                </div>
                {/* <div className="mb-0 justify-content-center flex-wrap">
                Showing 1 to 10 of 57 entries
              </div> */}
                <ul class="pagination mb-0 justify-content-center flex-wrap">
                  <li class="page-item mb-sm-0 mb-1 disabled">
                    <a class="page-link">Previous</a>
                  </li>
                  <li class="page-item mb-sm-0 mb-1">
                    <a class="page-link" href="#">
                      1
                    </a>
                  </li>
                  <li class="page-item mb-sm-0 mb-1 active">
                    <a class="page-link" href="#">
                      2
                    </a>
                  </li>
                  <li class="page-item mb-sm-0 mb-1">
                    <a class="page-link" href="#">
                      3
                    </a>
                  </li>
                  <li class="page-item mb-sm-0 mb-1">
                    <a class="page-link" href="#">
                      4
                    </a>
                  </li>
                  <li class="page-item mb-sm-0 mb-1">
                    <a class="page-link" href="#">
                      5
                    </a>
                  </li>
                  <li class="page-item mb-sm-0 mb-1">
                    <a class="page-link" href="#">
                      6
                    </a>
                  </li>
                  <li class="page-item mb-sm-0 mb-1">
                    <a class="page-link" href="#">
                      Next
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  );
}

export default Settings;
